import React from 'react';

import {
  equityFiltersQuery,
  equityAssetsQuery,
} from '../../../../../store/customerAssetDetail/selector';
import { DynamicAssetTableProps } from '../../DynamicAsset';
import { DynamicProductTable } from '../_dynamic';

import { tableHead } from './constants';
import ProductItem from './item';

export const EquityTable: React.FC<DynamicAssetTableProps> = (props) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={equityAssetsQuery}
      filtersQuery={equityFiltersQuery}
      tableHeadItems={tableHead}
      tabletColumns={5}
      tabletRows={2}
      mobileColumns={3}
      mobileRows={4}
      mobileFields={[
        { key: 'productNameNormalized', label: 'Ativo' },
        { key: 'productCategoryNormalized', label: 'Categoria' },
        { key: 'productTypeNormalized', label: 'Tipo' },
        { key: 'availableQuantityNormalized', label: 'Qtd. disponível' },
        { key: 'blockedQuantityNormalized', label: 'Qtd. bloqueada' },
        { key: 'totalQuantityNormalized', label: 'Qtd. total' },
        { key: 'averagePriceNormalized', label: 'Preço médio' },
        { key: 'actualPriceNormalized', label: 'Preço atual' },
        { key: 'resultNormalized', label: 'Resultado' },
        { key: 'variationNormalized', label: 'Variação', coloredField: 'variationType' },
        { key: 'valueNormalized', label: 'Valor' },
      ]}
      recommendedPortfolioInfoGetter={(item) => ({
        hasRecommendedPortfolioLink: item.hasRecommendedPortfolioLink,
        recommendedPortfolioLinks: item.recommendedPortfolioLinks,
      })}
    />
  );
};
